import React, { createRef, FC, useEffect } from "react";

export interface CheckboxProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  indeterminate?: boolean;
}

export const Checkbox: FC<CheckboxProps> = ({
  indeterminate = false,
  ...props
}) => {
  const ref = createRef<HTMLInputElement>();

  useEffect(() => {
    if (ref.current) {
      ref.current.indeterminate = indeterminate;
    }
  }, [indeterminate, ref]);

  return (
    <>
      <input ref={ref} type="checkbox" {...props} />
    </>
  );
};
